
import React, { useState, useEffect } from "react";

import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";
import Icon from "../../../components/AppIcon";
import { useDispatch, useSelector } from "react-redux";
import { getAllProductsService } from "redux/services/products_sevice";
import {
  getTagsService,
  getWorkshopsService,
} from "redux/services/workshops_service";

const ADVERTISEMENT_TYPES = {
  GENERAL: 1,
  WORKSHOP: 2,
  PRODUCT: 3,
  Emergency: 4,
};

const BannerAdsFormModal = ({
  isOpen,
  onClose,
  onSave,
  bannerAd,
  mode,
  language,
}) => {
  const dispatch = useDispatch();

  const { productList } = useSelector((state) => state.products);
  const { workshopsList, tagsList } = useSelector(
    (state) => state.workshops,
  );

  // ✅ فصل التاغات
  const productTags = tagsList?.filter((t) => t.is_product);
  const workshopTags = tagsList?.filter((t) => t.is_workshop);

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    body: "",
    image: null,
    advertisement_type: ADVERTISEMENT_TYPES.GENERAL,
    advertisement_link: "",
  });

  // ✅ كل الخيارات الممكنة
  const [selectedIds, setSelectedIds] = useState({
    product_id: "",
    workshop_id: "",
    product_tag_id: "",
    workshop_tag_id: "",
  });

  const [errors, setErrors] = useState({});
  const [imagePreview, setImagePreview] = useState("");

  useEffect(() => {
    if (bannerAd) {
      setFormData({
        title: bannerAd?.title || "",
        body: bannerAd?.body || "",
        image: null,
        advertisement_type:
          bannerAd?.advertisement_type || ADVERTISEMENT_TYPES.GENERAL,
        advertisement_link: bannerAd?.advertisement_link || "",
      });

      setSelectedIds({
        product_id: bannerAd?.product_id || "",
        workshop_id: bannerAd?.workshop_id || "",
        product_tag_id: bannerAd?.product_tag_id || "",
        workshop_tag_id: bannerAd?.workshop_tag_id || "",
      });

      setImagePreview(bannerAd?.image || "");
    } else {
      setFormData({
        title: "",
        body: "",
        image: null,
        advertisement_type: ADVERTISEMENT_TYPES.GENERAL,
        advertisement_link: "",
      });

      setSelectedIds({
        product_id: "",
        workshop_id: "",
        product_tag_id: "",
        workshop_tag_id: "",
      });

      setImagePreview("");
    }

    setErrors({});
  }, [bannerAd, isOpen]);

  const labels = {
    add: { en: "Add Banner Ad", ar: "إضافة إعلان" },
    edit: { en: "Edit Banner Ad", ar: "تعديل الإعلان" },
    title: { en: "Title", ar: "العنوان" },
    body: { en: "Body", ar: "الوصف" },
    image: { en: "Image", ar: "الصورة" },
    type: { en: "Advertisement Type", ar: "نوع الإعلان" },
    link: { en: "Advertisement Link", ar: "رابط الإعلان" },
    product: { en: "Product", ar: "منتج" },
    workshop: { en: "Workshop", ar: "ورشة" },
    productTag: { en: "Product Tag", ar: "وسم منتج" },
    workshopTag: { en: "Workshop Tag", ar: "وسم ورشة" },
    save: { en: "Save", ar: "حفظ" },
    cancel: { en: "Cancel", ar: "إلغاء" },
    required: { en: "Required field", ar: "حقل مطلوب" },
    invalidLink: { en: "Invalid URL", ar: "رابط غير صالح" },
    selectOne: { en: "Select one option", ar: "اختر عنصر واحد فقط" },
  };

  const advertisementTypesOptions = [
    { value: 1, label: "عام" },
    { value: 2, label: "ورشة" },
    { value: 3, label: "منتج" },
    { value: 4, label: "طوارئ" },
  ];

  // ✅ اختيار واحد فقط + تصفير الباقي
  const handleSelect = (type, value) => {
    setSelectedIds({
      product_id: type === "product" ? value : "",
      workshop_id: type === "workshop" ? value : "",
      product_tag_id: type === "product_tag" ? value : "",
      workshop_tag_id: type === "workshop_tag" ? value : "",
    });

    setErrors((prev) => ({ ...prev, selection: "" }));
  };

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.title.trim()) newErrors.title = labels.required[language];
    if (!formData.body.trim()) newErrors.body = labels.required[language];

    if (!imagePreview && !formData.image)
      newErrors.image = labels.required[language];

 

  /*  if (
      !selectedIds.product_id &&
      !selectedIds.workshop_id &&
      !selectedIds.product_tag_id &&
      !selectedIds.workshop_tag_id
    ) {
      newErrors.selection = labels.selectOne[language];
    }*/

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setLoading(true);

      onSave({
        ...formData,
        image: formData.image || imagePreview,
        ...selectedIds,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setFormData((prev) => ({ ...prev, image: file }));
    setImagePreview(URL.createObjectURL(file));
    setErrors((prev) => ({ ...prev, image: "" }));
  };

  useEffect(() => {
    dispatch(getAllProductsService({ page: 1 }));
    dispatch(getWorkshopsService({ page: 1 }));
    dispatch(getTagsService({ page: 1 }));
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center p-4">
      <div className="bg-card w-full max-w-4xl rounded-xl border border-border max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between mb-4">
            <h2 className="text-lg font-bold">
              {mode === "add" ? labels.add[language] : labels.edit[language]}
            </h2>
            <button onClick={onClose}>
              <Icon name="X" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label={labels.title[language]}
              value={formData.title}
              onChange={(e) =>
                setFormData({ ...formData, title: e.target.value })
              }
              error={errors.title}
            />

            <Input
              label={labels.body[language]}
              value={formData.body}
              onChange={(e) =>
                setFormData({ ...formData, body: e.target.value })
              }
              error={errors.body}
            />

            <Input
              label={labels.link[language]}
              value={formData.advertisement_link}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  advertisement_link: e.target.value,
                })
              }
              error={errors.advertisement_link}
            />

            <Select
              label={labels.type[language]}
              options={advertisementTypesOptions}
              value={formData.advertisement_type}
              onChange={(value) =>
                setFormData({
                  ...formData,
                  advertisement_type: value,
                })
              }
            />

            {/* Products */}
            <Select
              label={labels.product[language]}
              options={productList?.map((p) => ({
                value: p.id,
                label: p.name,
              }))}
              value={selectedIds.product_id}
              onChange={(v) => handleSelect("product", v)}
            />

            {/* Workshops */}
            <Select
              label={labels.workshop[language]}
              options={workshopsList?.map((w) => ({
                value: w.id,
                label: w.name,
              }))}
              value={selectedIds.workshop_id}
              onChange={(v) => handleSelect("workshop", v)}
            />

            {/* Product Tags */}
            <Select
              label={labels.productTag[language]}
              options={productTags?.map((t) => ({
                value: t.id,
                label: t.name,
              }))}
              value={selectedIds.product_tag_id}
              onChange={(v) => handleSelect("product_tag", v)}
            />

            {/* Workshop Tags */}
            <Select
              label={labels.workshopTag[language]}
              options={workshopTags?.map((t) => ({
                value: t.id,
                label: t.name,
              }))}
              value={selectedIds.workshop_tag_id}
              onChange={(v) => handleSelect("workshop_tag", v)}
            />

            {errors.selection && (
              <p className="text-sm text-error">{errors.selection}</p>
            )}

            {/* Image */}
            <div>
              <label className="text-sm font-medium">
                {labels.image[language]}
              </label>

              {imagePreview && (
                <img
                  src={imagePreview}
                  alt="preview"
                  className="h-40 w-full object-cover rounded mb-2"
                />
              )}

              <input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
              />

              {errors.image && (
                <p className="text-sm text-error">{errors.image}</p>
              )}
            </div>

            {/* Actions */}
            <div className="flex gap-3 pt-4">
              <Button
                type="button"
                variant="outline"
                fullWidth
                onClick={onClose}
                disabled={loading}
              >
                {labels.cancel[language]}
              </Button>

              <Button type="submit" fullWidth loading={loading}>
                {labels.save[language]}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BannerAdsFormModal;

